import { useMemo } from 'react';
import { createShowClient, type ShowClient } from '../api/showClient.js';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Bind a single {@link ShowClient} to the current auth session, mirroring {@link useAdminClient}.
 * The client reads the access token through the getter on each request (§32.3).
 */
export function useShowClient(): ShowClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => createShowClient(getAccessToken), [getAccessToken]);
}
